import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import { translations, LANGS } from "@/i18n/translations";

const LanguageContext = createContext(null);

function initialLang() {
  const param = new URLSearchParams(window.location.search).get("lang");
  if (param && translations[param]) return param;
  const saved = localStorage.getItem("aurafx_lang");
  if (saved && translations[saved]) return saved;
  return "en";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(initialLang);

  useEffect(() => {
    localStorage.setItem("aurafx_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((code) => {
    if (translations[code]) setLangState(code);
  }, []);

  const t = useCallback(
    (key) => translations[lang]?.[key] ?? translations.en[key] ?? key,
    [lang],
  );

  const value = useMemo(() => ({ lang, setLang, t, langs: LANGS }), [lang, setLang, t]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
